var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-content-center"},[_c('v-col',{staticClass:"text-center pt-0",attrs:{"sm":"12"}},[_c('iframe',{attrs:{"src":_vm.content.url,"width":_vm.content.settings.width,"height":_vm.content.settings.height}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }